export class ServiceInternetAcquiring {
  /** Получение данных по заказу для Тинькоффа */
  GetOrderingForTinkoff: string;

  /** Создание заявки */
  Create: string;

  /** Создание демо заявки */
  CreateDemo: string;

  /** Создание заказа YandexSplit*/
  RequestCreateOrderPaymentLink : string;

  constructor(url: string) {
    this.GetOrderingForTinkoff = `${url}/api/v1/ordering/getorderingfortinkoff`;
    this.Create = `${url}/api/v1/tinkoff/create`;
    this.CreateDemo = `${url}/api/v1/tinkoff/createdemo`;
    this.RequestCreateOrderPaymentLink = `${url}/api/v1/YandexPay/request-create-order-payment-link`;
  }
}